import React from 'react';
import { useTranslation } from 'react-i18next';

// components
import ChatBubble from 'eCoach/ChatBubble';

// hooks
import useUserNickname from 'shared/hooks/useUserNickname';

// styles
import * as Text from 'theme/components/Text.style';

export default function IntroMessage(): JSX.Element {
  const { t } = useTranslation('pageEcoach');
  const nickname = useUserNickname();

  const header = t(
    "chatStart.IntroMessage.What's on your mind about work today?",
    {
      nickname,
    }
  );

  const subheader = t(
    'chatStart.IntroMessage.The more details you give, the better your results will be. Always confidential.'
  );

  return (
    <ChatBubble>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
        <Text.P2>{header}</Text.P2>
        <Text.P2>{subheader}</Text.P2>
      </div>
    </ChatBubble>
  );
}
